import { DashboardCard } from "@tellescope/ui";
import { useTranslation } from "react-i18next";
import { TellescopeModelFromName, useTellescopeInfiniteQuery } from "@tellescope/tanstack-query";

export interface FormsSectionProps {
  contact: TellescopeModelFromName<"endusers">;
  onSelectForm?: (form: TellescopeModelFromName<"form_responses">) => void;
}

export const FormsSection = ({ contact, onSelectForm }: FormsSectionProps) => {
  const { t } = useTranslation("contacts");
  const { data: formResponses } = useTellescopeInfiniteQuery({
    model: "form_responses",
    method: "getSome",
    request: {
      filter: {
        enduserId: contact.id,
      },
    },
    select: (data) => data.pages.flat(),
  });

  const formCount = formResponses?.length;

  return (
    <div
      className={`flex-1 overflow-y-auto space-y-4 pr-2${
        !formCount ? "h-full flex items-center justify-center text-muted-foreground" : ""
      }`}
    >
      {formResponses?.length
        ? formResponses.map((form) => {
            return (
              <DashboardCard
                key={form.id}
                statusLabel=""
                title={form.formTitle}
                subtitle=""
                subtitleSecondary=""
                assignees={[]}
                description={`${form.responses?.length ?? 0} ${t("responses")}`}
                dueDate=""
                priority=""
                timestamp={undefined}
                className="w-full"
                onClick={() => {
                  onSelectForm?.(form);
                }}
              />
            );
          })
        : t("No Form Responses for This Contact")}
    </div>
  );
};
